import { IntlProvider } from 'react-intl'
import { useSelector } from 'react-redux'
import React, { FC, ReactNode, useEffect } from 'react'
import moment from 'moment'

export interface ITranslatitonProviderProps {
    children: ReactNode
}

export const TranslatitonProvider: FC<ITranslatitonProviderProps> = (props): JSX.Element => {
    const { locale, translations } = useSelector(({ translationModel }: any) => translationModel)
    useEffect(() => {
        // we don't need to import 'en' locale here, because it is already imported.
        // and it will throw an error if the locale is set to 'en'.
        // it must be specified which country, example: 'en-US'.
        if (locale !== 'en') {
            require(`moment/locale/${locale}`)
        }
        moment.locale(locale)
    }, [locale])
    return (
        <IntlProvider locale={locale} messages={translations}>
            {props.children}
        </IntlProvider>
    )
}
